import { useFormContext } from "react-hook-form"

import { ErrorMessage, Input, Switch } from "components/forms/FormElements"
import { formatAmountForDisplay } from "utils/stripe"

import HelpText from "./HelpText"

import type { ProductTypeBookingForm } from "./booking"
import type { ProductAddonWithImages } from "pages/products/[slug]"
import type { UseFormReturn } from "react-hook-form"

const Addon: React.FC<{ addon: ProductAddonWithImages }> = ({ addon }) => {
  const rhf = useFormContext() as UseFormReturn<ProductTypeBookingForm>
  return (
    <>
      {/* For single addon type use a switch */}
      {addon.type === "SINGLE" ? (
        <div className="flex items-center gap-2">
          <Switch
            label={addon.title}
            onClick={() => {
              rhf.setValue(
                `addons.${addon.id}.quantity`,
                rhf.getValues(`addons.${addon.id}.quantity`) === 1 ? 0 : 1
              )
            }}
            {...rhf.register(`addons.${addon.id}.quantity`)}
            checked={rhf.watch(`addons.${addon.id}.quantity`) === 1}
          />
          <span className="text-primary font-bold">
            {formatAmountForDisplay(addon.price || 0, "gbp")}
          </span>
          {addon.content && (
            <HelpText
              variant="inline"
              question="Hover for more info"
              helpContent={JSON.parse(addon.content)}
            />
          )}
        </div>
      ) : // For multiple addon type, register a quantity field
      addon.type === "MULTIPLE" ? (
        <div className="relative pt-3">
          <div>
            <Input
              type="number"
              showLabel
              customLabel={`${addon.title} - ${formatAmountForDisplay(
                addon.price || 0,
                "gbp"
              )} each`}
              {...rhf.register(`addons.${addon.id}.quantity`, {
                valueAsNumber: true,
                min: 0,
                max: 100,
                required: true,
                onChange: e => {
                  if (e.target.valueAsNumber < 0) {
                    rhf.setValue(`addons.${addon.id}.quantity`, 0)
                  }
                }
              })}
            />
            {rhf.formState.errors.addons?.[addon.id] && (
              <ErrorMessage>
                {rhf.formState.errors.addons?.[addon.id]?.type === "required"
                  ? "Please enter a quantity"
                  : "Please enter a quantity less than 100"}
              </ErrorMessage>
            )}
          </div>
          <HelpText
            variant="absolute"
            question="Hover for more info"
            helpContent={JSON.parse(addon.content || "")}
          />
        </div>
      ) : // Do nothing if addon type is template. These are rendered on the optional extras/addons page and I'm creating separate steps for addons currently. Might need to use in future though
      null}
    </>
  )
}

export default Addon
